import { Input, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Spacing } from '../components/modals/tabs/advanced/columns-modal-advanced.component';
import { ParametricModal } from 'app/infrastructure/model/interfaces/parametricModal.interface';
import { DescOptions } from './view-engine.interface';

export class AttributeChangeEventArgsType {
  oldValue: any;
  newValue: any;
  attName: string;
  constructor(oldValue: any, newValue: any, attName: string) {
    this.oldValue = oldValue;
    this.newValue = newValue;
    this.attName = attName;
  }
}

export class DesignAttributeType {
  // tipo de atributo
  public type: string;
  // nombre
  public name: string;
  // valor
  private _value: any;
  // es la etiqueta que se muestra en el form
  public label: string;
  // Condiciones bajo las cuales se oculta el attributo [campo, condicion, valor]. Ejemplo ['ruleValue','==','test']
  public hiddenConditions: [string, string, any][] = [];
  public isHidden: boolean = false;
  get value(): any {
    return this._value;
  }

  @Input('value')
  set value(value: any) {
    this._value = value;
    this.acceptChanges();
  }
  // Eventos
  change: EventEmitter<AttributeChangeEventArgsType> = new EventEmitter();

  constructor(
    private controlProperty: any,
    type: string,
    name: string,
    label?: string
  ) {
    this.type = type;
    this.name = name;
    this.label = label;

    if (!this.label) {
      this.label = this.name;
    }

    this._value = this.controlProperty[this.name];
  }

  updateVisibility(attributeChanged: string, newValue: any) {
    this.hiddenConditions.forEach((cond) => {
      var attribute = cond[0];
      var operator = cond[1];
      var valueToHidden = cond[2];

      if (attributeChanged == attribute) {
        switch (operator) {
          case '==': {
            this.isHidden = newValue == valueToHidden;
            break;
          }
          case '===': {
            this.isHidden = newValue == valueToHidden;
            break;
          }
          case '!=': {
            this.isHidden = newValue != valueToHidden;
            break;
          }
          case '>': {
            this.isHidden = newValue > valueToHidden;
            break;
          }
          case '<': {
            this.isHidden = newValue < valueToHidden;
            break;
          }
        }
      }
    });
  }

  checkInitialVisibility(attributes: DesignAttributeType[]) {
    attributes.forEach((att) => {
      this.updateVisibility(att.name, att.value);
    });
  }

  acceptChanges(): void {
    // evento de cambio de valor
    this.change.emit(
      new AttributeChangeEventArgsType(
        this.controlProperty[this.name],
        this._value,
        this.name
      )
    );
    this.controlProperty[this.name] = this._value;
  }
}

export class AttributeReference extends DesignAttributeType {
  public options: any;

  constructor(
    controlProperty: any,
    options: any,
    name: string,
    label?: string
  ) {
    super(controlProperty, 'attributeReference', name, label);
    this.options = options;
  }
}

export class OptionsAttribute extends DesignAttributeType {
  public options: any;
  constructor(
    controlProperty: any,
    options: any,
    name: string,
    label?: string
  ) {
    super(controlProperty, 'options', name, label);
    this.options = options;
  }
}

export class ColumnsAttribute extends DesignAttributeType {
  // this will be raised on save
  onSave = new EventEmitter<any>();
  onRaise = new BehaviorSubject<any[]>(null);
  spacing: Spacing;
  constructor(
    controlProperty: any,
    type: any,
    name: string,
    label?: string,
    spacing?: Spacing
  ) {
    super(controlProperty, type, name, label);
    this.spacing = spacing;
  }
}

export class OutputAttribute extends DesignAttributeType {
  pageOptions: Array<DescOptions>;
  ruleOptions: Array<DescOptions>;
  ouputTypes: Array<DescOptions>;
  flowOptions: Array<DescOptions>;
  constructor(
    controlProperty: any,
    ruleoptions: Array<DescOptions>,
    pageoptions: Array<DescOptions>,
    ouputTypes: Array<DescOptions>,
    flowOptions: Array<DescOptions>,
    type: any,
    name: string,
    label?: string
  ) {
    super(controlProperty, type, name, label);
    this.pageOptions = pageoptions;
    this.ruleOptions = ruleoptions;
    this.flowOptions = flowOptions;
    this.ouputTypes = ouputTypes;
  }
}

export class InputAttribute extends DesignAttributeType {
  inputTypes: Array<DescOptions>;
  constructor(
    controlProperty: any,
    inputTypes: Array<DescOptions>,
    type: any,
    name: string,
    label?: string
  ) {
    super(controlProperty, type, name, label);
    this.inputTypes = inputTypes;
  }
}

export class RuleAttribute extends DesignAttributeType {
  public options: any;

  constructor(
    controlProperty: any,
    options: any,
    name: string,
    label?: string
  ) {
    super(controlProperty, 'rule', name, label);
    this.options = options;
  }
}

export class PageNavigationAttribute extends DesignAttributeType {
  public options: any;

  constructor(
    controlProperty: any,
    options: any,
    name: string,
    label?: string
  ) {
    super(controlProperty, 'page', name, label);
    this.options = options;
  }
}

export class FlowNavigationAttribute extends DesignAttributeType {
  public options: any;

  constructor(
    controlProperty: any,
    options: any,
    name: string,
    label?: string
  ) {
    super(controlProperty, 'flowNav', name, label);
    this.options = options;
  }
}

export class RichTextAttribute extends DesignAttributeType {
  constructor(controlProperty: any, name: string, label?: string) {
    super(controlProperty, 'richtext', name, label);
  }
}

export class ImageAttribute extends DesignAttributeType {
  constructor(controlProperty: any, name: string, label?: string) {
    super(controlProperty, 'image', name, label);
  }
}

export class ModalTextAttribute extends DesignAttributeType implements ParametricModal {
  additionalParameters: string[];

  // Component to open in modal
  modal: any;

  constructor(
    controlProperty: any,
    name: string,
    modal: any,
    label?: string
  ) {
    super(controlProperty, 'modalText', name, label);

    this.modal = modal;
  }

  setParameters(additional: string[]): void {
    this.additionalParameters = additional;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/types/designer-attribute-type.ts